import React from 'react';
import TableCell from '@material-ui/core/TableCell';

function Celda(props) {
   const {valor, registro, nombreCampo, titulo, children, ...other} = props;

   return <TableCell {...other}>{children}</TableCell>;
}

export default Celda;
